import { useEffect, useState } from "react";
import Overlay from "../../Componentes/Overlay"
import Modal from "../../Componentes/Utils/Modal"
import axios from "axios";
import styled from "styled-components";
import { formatarData } from "../../Funcoes/FormatarData";
import { saveAs } from "file-saver";

const Container = styled.div`
    width: 100%;
    background-color: #FFF;
    border-radius: 12px;
    border: 1px solid #CCC;
    box-sizing: border-box;
    overflow-x: auto;
`
const Tabela = styled.table`
    width: 100%;
    min-width: 800px;
    border-collapse: collapse;
    box-sizing: border-box;
`
const TituloCelula = styled.th`
    text-align: left;
    border-bottom: 1px solid #CCC;
    padding: 10px 0 10px 10px;
    & h3 {
        margin: 0;
        font-size: 15px;
    }
    color: #000;
`
const TitleHeader = styled.th`
    padding: 10px 0 10px 14px;
    text-align: left;
    border-bottom: 1px solid #bbbbbb;
    font-size: 13px;
    color: #000;
`
const LinhaCorpo = styled.tr`
    &:nth-child(even) {
        background-color: #f9f9f9;
    }
    &:hover {
        background-color: #d8f2ee;
    }
    border-bottom: 1px solid #CCC;
    &:last-child{
        border: none;
    }
`
const CelulaValor = styled.td`
    padding: 10px 15px 10px 15px;
    text-align: left;
    font-size: 12px;
    color: #555;
    width: ${({ width }) => (width ? `${width}px` : 'auto')};
    white-space: nowrap;
`
const ContainerDownBtn = styled.div`
    width: 100%;
    display: flex;
`
const DowloadBtn = styled.button`
    height: 40px;
    background-color: green;
    margin: 10px 0 15px auto;
    border: none;
    border-radius: 8px;
    color: #fff;
    box-sizing: border-box;
    padding: 0 15px;
    font-weight: bold;
    cursor: pointer;
    transition: all.3s;
    &:hover{
        scale: 1.05;
    }
`

const ModalAddedTreinamentos = ({ treinamentos, fechar }) => {

    const [loading, setLoading] = useState(true);

    const [listaTreinamentos, setListaTreinamentos] = useState([]);

    const fetchTreinamentos = async () => {

        try {
            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/Treinamentos/GetTreinamentosByID/', {
                itens: treinamentos
            })

            setListaTreinamentos(data);
            console.log(data)
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {

        if (!treinamentos) {
            return;
        }

        fetchTreinamentos();

    }, [treinamentos])

    const [downloading, setDownloading] = useState(false);

    const downloadFiles = async () => {

        if (listaTreinamentos.length === 0) {
            return;
        }

        setDownloading(true);

        try {
            for (const item of listaTreinamentos) {
                const { data } = await axios.post(
                    "https://sistemaintegrado.palmont.com.br/Painel/API/Treinamentos/GenerateCertificado/",
                    { id_treinamento: item.id },
                    { responseType: "blob" }
                );

                const pdfBlob = new Blob([data], { type: "application/pdf" });

                const fileName = `${item.nome} - ${item.treinamento}`
                    .replace(/[\\/:*?"<>|]/g, "-");

                saveAs(pdfBlob, `${fileName}.pdf`);
            }
        } catch (error) {
            console.error("Erro ao baixar certificados:", error);
        } finally {
            setDownloading(false);
        }
    };

    return (
        <>
            <Overlay state={true} >
                <Modal size="lg" header close={fechar} >
                    <ContainerDownBtn>
                        <DowloadBtn onClick={downloadFiles} >BAIXAR CERTIFICADOS</DowloadBtn>
                    </ContainerDownBtn>
                    <Container>
                        <Tabela>
                            <thead>
                                <tr>
                                    <TituloCelula colSpan={6} >
                                        <h3>TREINAMENTOS GERADOS</h3>
                                    </TituloCelula>
                                </tr>
                                <tr>
                                    <TitleHeader>ID</TitleHeader>
                                    <TitleHeader>COLABORADOR</TitleHeader>
                                    <TitleHeader>TREINAMENTO</TitleHeader>
                                    <TitleHeader>INÍCIO</TitleHeader>
                                    <TitleHeader>TÉRMINO</TitleHeader>
                                    <TitleHeader>INSTRUTOR</TitleHeader>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    listaTreinamentos.map((obj) => ((
                                        <LinhaCorpo key={obj.id} >
                                            <CelulaValor>{obj.id}</CelulaValor>
                                            <CelulaValor>{obj.nome}</CelulaValor>
                                            <CelulaValor>{obj.treinamento}</CelulaValor>
                                            <CelulaValor>{obj.data_inicio ? formatarData(obj.data_inicio) : ""}</CelulaValor>
                                            <CelulaValor>{obj.data_termino ? formatarData(obj.data_termino) : ""}</CelulaValor>
                                            <CelulaValor>{obj.instrutor}</CelulaValor>
                                        </LinhaCorpo>
                                    )))
                                }
                            </tbody>
                        </Tabela>
                    </Container>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalAddedTreinamentos;